import api from "./api";
import {
  ReadingHabitsData,
  MonthlySummary,
  BookProgress,
  WeeklyGoals,
  UserStats,
} from "../types";

const STATS_ENDPOINT = "/stats";

export const statsService = {
  async getUserStats(signal?: AbortSignal): Promise<UserStats> {
    const response = await api.get<UserStats>("/users/me/stats", { signal });
    return response.data;
  },

  // Get reading habits
  async getReadingHabits(
    days: number = 30,
    signal?: AbortSignal
  ): Promise<ReadingHabitsData> {
    const response = await api.get<ReadingHabitsData>(
      `${STATS_ENDPOINT}/reading-habits`,
      { params: { days }, signal }
    );
    return response.data;
  },

  // Get monthly summary
  async getMonthlySummary(
    year?: number,
    signal?: AbortSignal
  ): Promise<MonthlySummary> {
    const response = await api.get<MonthlySummary>(
      `${STATS_ENDPOINT}/monthly-summary`,
      { params: { year }, signal }
    );
    return response.data;
  },

  // Get book progress
  async getBookProgress(
    bookId?: number,
    signal?: AbortSignal
  ): Promise<{ book_progress: BookProgress[] }> {
    const response = await api.get<{ book_progress: BookProgress[] }>(
      `${STATS_ENDPOINT}/book-progress`,
      { params: { book_id: bookId }, signal }
    );
    return response.data;
  },

  // Get weekly goals
  async getWeeklyGoals(signal?: AbortSignal): Promise<WeeklyGoals> {
    const response = await api.get<WeeklyGoals>(`${STATS_ENDPOINT}/weekly-goals`, {
      signal,
    });
    return response.data;
  },
};
